import { formatQueryParams } from 'utils/exchanges'

import Api from '../Api'

export async function getExchanges(url) {
  const response = await Api.get(formatQueryParams(url))
  return response.data
}
